import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const nlSimulatorResponseContract = c.router({
  postNlSimulatorCallback: {
    method: 'POST',
    path: '/nl-simulator-callback',
    body: z.object({
      name: z.string(),
      bucket: z.string(),
      kind: z.string(),
    }),
    responses: {
      200: z.object({ success: z.boolean() }),
    },
  },
});
